import { render } from "./OrderHistoryMypayment.vue?vue&type=template&id=09db85a2&lang=html"
import script from "./OrderHistoryMypayment.vue?vue&type=script&lang=js"
export * from "./OrderHistoryMypayment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__